<template>
  <dx-cell v-bind="$attrs" v-on="$listeners">
    <a
      href="javascript:void(0)"
      v-on:click="disable($attrs.tableRow.row.id, true)"
      :title="title"
      v-b-tooltip.hover 
    >
      <i :class="icon"></i>
    </a>
  </dx-cell>
</template>

<script>
import { DxGrid, DxTable } from '@devexpress/dx-vue-grid-bootstrap4';
import Cell from './Cell';
import axios from 'axios';

export default {
  inheritAttrs: false,
  props: ['value'],
  components: {
    DxCell: DxTable.components.DxCell,
  },
  methods: {
    disable: function(id, isDeleteWithConfirm = true) {
      this.$swal({
        icon: 'warning',
        title: this.$t('Предупреждение'),
        text: this.$attrs.tableRow.row.isNotificationDisabled ? this.$t('Вы уверены, что хотите включить эту рассылку?') : this.$t('Вы уверены, что хотите отключить эту рассылку?'),
        buttons: [this.$t('Нет'), this.$t('Да')],
        }).then((willDelete) => {
          if(willDelete) {
        axios.delete(this.$route.path + '?id=' + id)
        .then((response) => {
          this.$router.go({
            path: this.$route.path,
            force: true,
          });
        })
          }
       
        });
    },
  },
  computed: {
    title() {
      return this.$attrs.tableRow.row.isNotificationDisabled ? this.$t('Включить') : this.$t('Отключить');
    },
    icon() {
      return this.$attrs.tableRow.row.isNotificationDisabled
        ? 'fa fa-ban'
        : 'fa fa-check';
    },
  },
};
</script>

<style>
.swal-button--confirm {
  background-color: #009688 !important;
}
.swal-footer {
    display: flex;
    flex-flow: row-reverse;
}
</style>
